import { PushDeviceStatusPanel } from './PushDeviceStatusPanel';
/**
 * The panel owns its own fetch, so each story points at a different mock
 * endpoint path; Storybook's network layer is expected to answer them. The
 * value here is the seven states rendered side by side — the whole reason the
 * panel keeps them distinct rather than collapsing failures into one "error".
 */
const meta = {
    title: 'Features/Settings/Technicians/PushDeviceStatusPanel',
    component: PushDeviceStatusPanel,
    parameters: { layout: 'padded' }
};
export default meta;
export const Registered = {
    args: { statusUrl: '/technicians/7/push_device_status' }
};
export const NoDevice = {
    args: { statusUrl: '/technicians/8/push_device_status' }
};
export const ApiKeyRejected = {
    args: { statusUrl: '/technicians/9/push_device_status' }
};
export const PlatformUnreachable = {
    args: { statusUrl: '/technicians/10/push_device_status' }
};
